<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="file import icon"></i>
      {{ $t("import report") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/report.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <file-uploader
          name="file"
          url="/report_composer/do-upload-import"
          @error="error_uploading"
          @uploaded="end_uploading"
          ref="file_uploader"
        />
        <!-- <file-pond
          name="file"
          ref="pond"
          :label-idle="$t('click or drop files here')"
          v-bind:allow-multiple="false"
          v-bind:allow-revert="false"
          v-bind:server="{
            url: api_host,
            timeout: enterprise_setup.upload_timeout,
            process: {
              url: '/ngine_composer/project/do-upload-import',
              method: 'POST',
              headers: {
                'x-access-token': token_session,
              },
              withCredentials: false,
            },
          }"
          v-on:error="filepond_error"
          v-on:processfile="filepond_process"
        /> -->
        <div class="ui fluid card" v-if="import_summary">
          <div class="content">
            <div class="ui items">
              <div class="ui item">
                <a class="ui tiny image">
                  <img src="/images/icons/summary.png" />
                </a>
                <div class="content">
                  <a class="header">{{ import_summary.name }}</a>
                  <div class="description">
                    <p>
                      {{ import_summary.module_name }} <br />{{
                        import_summary.description
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="extra">
              <div class="ui list">
                <div class="item">
                  <i
                    class="icon"
                    v-bind:class="{
                      'green check': import_summary.setup.input_screen_html,
                      'red remove': !import_summary.setup.input_screen_html,
                    }"
                  ></i>
                  {{ $t("input screen html") }}
                </div>
                <div class="item">
                  <i
                    class="icon"
                    v-bind:class="{
                      'green check': import_summary.setup.input_screen_js,
                      'red remove': !import_summary.setup.input_screen_js,
                    }"
                  ></i
                  >{{ $t("input screen js") }}
                </div>
                <div class="item">
                  <i
                    class="icon"
                    v-bind:class="{
                      'green check': import_summary.setup.result_screen_html,
                      'red remove': !import_summary.setup.result_screen_html,
                    }"
                  ></i
                  >{{ $t("result screen html") }}
                </div>
                <div class="item">
                  <i
                    class="icon"
                    v-bind:class="{
                      'green check': import_summary.setup.result_screen_js,
                      'red remove': !import_summary.setup.result_screen_js,
                    }"
                  ></i
                  >{{ $t("result screen js") }}
                </div>
                <div class="item">
                  <i
                    class="icon"
                    v-bind:class="{
                      'green check': import_summary.setup.database_query,
                      'red remove': !import_summary.setup.database_query,
                    }"
                  ></i
                  >{{ $t("database query") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
      <div class="ui blue icon right labeled negative button">
        <i class="close icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import FileUploader from "@/components/FileUploader.vue";
// import moment from "moment";
// import GenericModal from "@/components/GenericModal";
// import General from "./General";

export default {
  name: "ReportImportModal",
  components: {
    FileUploader,
    // "generic-modal": GenericModal,
    // General,
  },
  computed: {},
  props: {},
  data() {
    return {
      import_summary: undefined,
    };
  },
  methods: {
    show_modal(options) {
      let vm = this;
      if (options) {
        console.log("options", options);
      }
      // console.log(options);
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            // console.log(vm.$refs);
            window.jQuery(vm.$refs.form).form("clear");
            vm.$refs.file_uploader.clear();
            vm.import_summary = undefined;
          },
          onShow() {},
        })
        .modal("show");
    },
    save() {
      let vm = this;
      // let isValid = window.jQuery(vm.$refs.form).form("validate form");
      // let validTemplateRules = vm.validate_rules();
      // if (isValid && validTemplateRules) {
      local_api(vm, "post", "/report_composer/do-import", vm.import_summary)
        .then(() => {
          vm.$emit("saved");
          window.jQuery(vm.$refs.modal).modal("hide");
        })
        .catch((err) => {
          error_toast(err);
        });
      // }
    },
    error_uploading(err) {
      console.error(err);
    },
    end_uploading(file) {
      let vm = this;
      vm.import_summary = file;
    },
  },
  created() {},
  mounted() {
    // let vm = this;
  },
  updated: function () {},
  watch: {},
};
</script>

<style></style>
